export const dealConstants = {
 GET_DEALCURRENT_REQUEST:         'GET_DEALCURRENT_REQUEST',
 GET_DEALCURRENT_SUCCESS:         'GET_DEALCURRENT_SUCCESS',
 GET_DEALCURRENT_FAILURE:         'GET_DEALCURRENT_FAILURE',
 DELETE_DEAL_REQUEST:             'DELETE_DEAL_REQUEST',
 DELETE_DEAL_SUCCESS:             'DELETE_DEAL_SUCCESS',
 DELETE_DEAL_FAILURE:             'DELETE_DEAL_FAILURE',
 GET_DEALDETAIL_REQUEST:          'GET_DEALDETAIL_REQUEST',
 GET_DEALDETAIL_SUCCESS:          'GET_DEALDETAIL_SUCCESS',
 GET_DEALDETAIL_FAILURE:          'GET_DEALDETAIL_FAILURE',
 EDIT_DEALLIST_REQUEST:           'EDIT_DEALLIST_REQUEST',
 EDIT_DEALLIST_SUCCESS:           'EDIT_DEALLIST_SUCCESS',
 EDIT_DEALLIST_FAILURE:           'EDIT_DEALLIST_FAILURE',
 ADD_DEALLOC_REQUEST:             'ADD_DEALLOC_REQUEST',
 ADD_DEALLOC_SUCCESS:            'ADD_DEALLOC_SUCCESS',
 ADD_DEALLOC_FAILURE:            'ADD_DEALLOC_FAILURE',
 GET_DEALCITIES_REQUEST:          'GET_DEALCITIES_REQUEST',
 GET_DEALCITIES_SUCCESS:          'GET_DEALCITIES_SUCCESS',
 GET_DEALCITIES_FAILURE:          'GET_DEALCITIES_FAILURE', 
 DELETE_DEAL_LOCATION_REQUEST:    'DELETE_DEAL_LOCATION_REQUEST',
 DELETE_MERCHANT_LOCATION_SUCCESS:'DELETE_MERCHANT_LOCATION_SUCCESS',
 DELETE_DEAL_LOCATION_FAILURE:    'DELETE_DEAL_LOCATION_FAILURE',
 DELETE_DEAL_LOCATION_SUCCESS: 	  'DELETE_DEAL_LOCATION_SUCCESS',
 DELETE_IMAGE_REQUEST:            'DELETE_IMAGE_REQUEST',
 DELETE_IMAGE_SUCCESS:            'DELETE_IMAGE_SUCCESS',
 DELETE_IMAGE_FAILURE:            'DELETE_IMAGE_FAILURE',
 GET_DEALPENDING_REQUEST:         'GET_DEALPENDING_REQUEST',
 GET_DEALPENDING_SUCCESS:         'GET_DEALPENDING_SUCCESS',
 GET_DEALPENDING_FAILURE:         'GET_DEALPENDING_FAILURE',
 GET_DEALUPCOMING_REQUEST:        'GET_DEALUPCOMING_REQUEST',
 GET_DEALUPCOMING_SUCCESS:        'GET_DEALUPCOMING_SUCCESS',
 GET_DEALUPCOMING_FAILURE:        'GET_DEALUPCOMING_FAILURE',
 GET_DEALPAST_REQUEST:            'GET_DEALPAST_REQUEST',
 GET_DEALPAST_SUCCESS:            'GET_DEALPAST_SUCCESS',
 GET_DEALPAST_FAILURE:            'GET_DEALPAST_FAILURE',
 GET_DEALORDER_REQUEST: 		  'GET_DEALORDER_REQUEST',
 GET_DEALORDER_SUCCESS: 		  'GET_DEALORDER_SUCCESS',
 GET_DEALORDER_FAILURE: 		  'GET_DEALORDER_FAILURE',
 CONFIRM_CLOSE_REQUEST: 		  'CONFIRM_CLOSE_REQUEST',
 CONFIRM_CLOSE_SUCCESS: 		  'CONFIRM_CLOSE_SUCCESS',
 CONFIRM_CLOSE_FAILURE: 		  'CONFIRM_CLOSE_FAILURE',
 POST_EXTERNAL_SUCCESS: 		  'POST_EXTERNAL_REQUEST',
 POST_EXTERNAL_SUCCESS: 		  'POST_EXTERNAL_SUCCESS',
 POST_EXTERNAL_FAILURE: 		  'POST_EXTERNAL_FAILURE',
 GET_ORDER_DEALS_REQUEST: 		  'GET_ORDER_DEALS_REQUEST',
 GET_ORDER_DEALS_SUCCESS: 		  'GET_ORDER_DEALS_SUCCESS',
 GET_ORDER_DEALS_FAILURE: 		  'GET_ORDER_DEALS_FAILURE',
 SAVE_ORDER_DEALS_REQUEST: 		  'SAVE_ORDER_DEALS_REQUEST',
 SAVE_ORDER_DEALS_SUCCESS: 		  'SAVE_ORDER_DEALS_SUCCESS',
 SAVE_ORDER_DEALS_FAILURE: 		  'SAVE_ORDER_DEALS_FAILURE',
 POST_UPEXTERNAL_REQUEST: 		  'POST_UPEXTERNAL_REQUEST',
 POST_UPEXTERNAL_SUCCESS: 		  'POST_UPEXTERNAL_SUCCESS',
 POST_UPEXTERNAL_FAILURE: 		  'POST_UPEXTERNAL_FAILURE',
 POST_ATTRIBUTE_REQUEST: 		  'POST_ATTRIBUTE_REQUEST',
 POST_ATTRIBUTE_SUCCESS: 		  'POST_ATTRIBUTE_SUCCESS',
 POST_ATTRIBUTE_FAILURE: 		  'POST_ATTRIBUTE_FAILURE',
 UPLOAD_IMAGE_REQUEST: 			  'UPLOAD_IMAGE_REQUEST',
 UPLOAD_IMAGE_SUCCESS: 			  'UPLOAD_IMAGE_SUCCESS',
 UPLOAD_IMAGE_FAILURE: 			  'UPLOAD_IMAGE_FAILURE',
 UPDATE_DEAL_IMG_ORD_REQUEST:	  'UPDATE_DEAL_IMG_ORD_REQUEST',
 UPDATE_DEAL_IMG_ORD_SUCCESS:	  'UPDATE_DEAL_IMG_ORD_SUCCESS',
 UPDATE_DEAL_IMG_ORD_FAILURE:	  'UPDATE_DEAL_IMG_ORD_FAILURE',
 GET_DEALSCHEDULE_REQUEST: 		  'GET_DEALSCHEDULE_REQUEST',
 GET_DEALSCHEDULE_SUCCESS: 		  'GET_DEALSCHEDULE_SUCCESS',
 GET_DEALSCHEDULE_FAILURE: 		  'GET_DEALSCHEDULE_FAILURE',
 UPDATE_QUANTITY_REQUEST: 		  'UPDATE_QUANTITY_REQUEST',
 UPDATE_QUANTITY_SUCCESS: 		  'UPDATE_QUANTITY_SUCCESS',
 UPDATE_QUANTITY_FAILURE: 		  'UPDATE_QUANTITY_FAILURE',
 GET_CHILDDEALS_REQUEST: 		  'GET_CHILDDEALS_REQUEST',
 GET_CHILDDEALS_SUCCESS: 		  'GET_CHILDDEALS_SUCCESS',
 GET_CHILDDEALS_FAILURE: 		  'GET_CHILDDEALS_FAILURE',
 GET_DEALCONTRACT_REQUEST: 		  'GET_DEALCONTRACT_REQUEST',
 GET_DEALCONTRACT_SUCCESS: 		  'GET_DEALCONTRACT_SUCCESS',
 GET_DEALCONTRACT_FAILURE: 		  'GET_DEALCONTRACT_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/dealConstants.js